import React from 'react';
import { connect } from 'react-redux'
import { List, Button, message, Modal } from 'antd';
import i18n from "i18next";
import { subsetByLang, getLangValue, updateTripletsByObjectValue } from '../../virtuoso/helper';
import { WikiActions, AdmsAsset, RdfTriplet } from '../../redux';
import WikiSelectPage from './WikiSelectPage';
import { WikiPageListItem } from './WikiPageSmall';
import { makeDescription, makeIRIPage, makeURL } from './helper';
const { confirm } = Modal;

const showAdd = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  console.log("WikiValues.js  showAdd", selected);
  const isPage = (selected) && (selected.pageId);
  const okButtonProps={disabled: !isPage};
  return (
    <Modal 
        style={{minWidth: 700}} visible={true} 
        title={i18n.t('components.wiki.select.title')}
        cancelText={i18n.t('components.wiki.select.cancelText')} 
        okText={i18n.t('components.wiki.select.okText')} 
        onCancel={onCancelOperation} 
        onOk={onFinishOperation} 
        okButtonProps={okButtonProps}>	
      <WikiSelectPage wrappedComponentRef={formRef} />
	  </Modal>
    )
}

const TopRow = () => 
    <tr className="top-row">
        <td className="top-left-corner"></td>
        <td className="top-middle"></td>
        <td className="top-right-corner"></td>
    </tr>
const BottomRow = () =>
    <tr className="bottom-row">
        <td className="bottom-left-corner"></td>
        <td className="bottom-middle"></td>
        <td className="bottom-right-corner"></td>
    </tr>

/** Отображение таксономии.  Для отображения используется List (см. https://ant.design/components/list/), который содержит:
 * 1. Заголовок - название такосномии (наименование КонцептСхемы). 
 * 2. Тело - значение (наименование концепта)
 * 3. Входным прараметром является URI предиката, который содержит объекты (object, обычно IRI) значений.
 * Для SKOS это индивидуалы skos:Concept 
 * 
 * При получении URI предиката, подучаем список IRI, которые содержат значения таксономии (для SKOS это skos:Concept)
 * 
 * */
class WikiCard extends React.Component {
  state = {
    loading: false,
    modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог выбора wiki статьи
    wikies: [],
  }
  
  saveFormRef = formRef => {
    this.formRef = formRef;
  }

  componentDidMount() {
    this.loadDetails();
  }

  cancelOperation(){
    this.setState({modal:"none"});
  }

  submitOperation() {
    //console.log('submitOperation() ', this.props.selected);
    const { asset, lang, selected, nodes, onAddElement} = this.props;
    onAddElement(AdmsAsset, asset, makeIRIPage(asset,selected), selected.title, makeDescription(selected), makeURL(nodes, selected), lang)
      .then (result =>{
          //console.log("onAddElement", result);
          message.success(i18n.t('components.wiki.message.ok_link'));
        })
    this.setState({modal:"none"});
  };

  /** Удаление Distribution */
  handleDeleteWiki (e, IRI, header) {
    e.preventDefault();
    //console.log("handleDeleteWiki (e, IRI)", IRI, e, header, this);
    const { asset, onDeleteElement } = this.props;
    confirm({ title: i18n.t('components.wiki.unlink_dialog.title'), content: header, 
      okText: i18n.t('components.wiki.unlink_dialog.okText'), okType: 'danger', 
      cancelText: i18n.t('components.wiki.unlink_dialog.cancelText'),
      onOk() { 
        onDeleteElement(AdmsAsset, asset, IRI)
          .then (result =>{
              console.log("onDeleteElement", result);
              message.success(i18n.t('components.wiki.message.ok_unlink'));
            })
      },
      onCancel() {},
    });
//this.setState({modal:"view", selected: IRI});
  };

  componentWillReceiveProps(nextProps){
    const {wikies} = nextProps;
    //Есть незагруженное описания распространения актива
    if (wikies && Array.isArray(wikies) && (wikies.filter(d=> d.state!="loaded").length>0))
      this.loadDetails(wikies);
  }

  loadDetails(items=null) {
    const {wikies, lang, graph, onLoadDetailWikies} = this.props;
    this.setState({loading: true});
    const values = (items)?items:wikies;
    //Получаем список ссылок
    const data = subsetByLang(values, lang);
    const requests = data.map(wiki => RdfTriplet.loadSubject(wiki.object.value, graph));
    //Получим описание всех элементов и обновим wiki
    Promise.all(requests).then(result => {
       result.forEach(wiki => {
          //определим исходный источник, т.к. нужно указать в параметрах lang, для которого нужно сделать обновление
          const sources = data.filter(item => item.object.value == wiki.subject);
          const findLang = (sources && (sources.length>0))? getLangValue(sources[0]): undefined;
          updateTripletsByObjectValue({values: wiki.bindings, state: "loaded"}, values, wiki.subject, findLang);
       });
       onLoadDetailWikies(AdmsAsset, values);
       this.setState({loading: false});
    }).catch( e => {
      data.forEach(wiki => {
        updateTripletsByObjectValue({state: "error"}, values, wiki.object.value);
      });
      onLoadDetailWikies(AdmsAsset, values);
      this.setState({loading: false});
      message.error(i18n.t('components.wiki.message.e_detail', {detail: e}));
    })
  };
    
  onAction (e, type, item) {
    e.preventDefault();
    console.log("onAction (e, type, item)", e, type, item);
    this.props.onLoadNodes()
      .then(response => {
        console.log("result", response);
        this.setState({modal:"add"});
      })
      .catch(e => {
        message.error(i18n.t('components.wiki.message.e_detail', {detail: e})); //`Ошибка при поиске статей. ${e}; 
      });
  };
    
  render() {
    console.log(this);
    const { loading, modal } = this.state;
    const { wikies, operation, factory } = this.props;
    const isModified = (operation == "edit");
    const hasWikiPage = (wikies && Array.isArray(wikies) && wikies.length>0);
   return (
     <span>
              {isModified && <div class="ant-btn-group" style={{background: "rgb(128, 128, 128)"}}><Button type="dashed" size="small" icon="edit" ghost onClick={(e)=> this.onAction(e, "add")}>Связать</Button></div>}
              {(modal=="add" )&& showAdd( this.saveFormRef, ()=>this.submitOperation(), ()=>this.cancelOperation(), this.props.selected)}
              {!hasWikiPage && 
                <ul class="ant-list-items">
                  <li class="ant-list-item">
                    <div class="ant-list-item-meta">
                      <div class="ant-list-item-meta-content">
                        <h4 class="ant-list-item-meta-title"><span class="csi_cat_title">{i18n.t('components.wiki.title')}</span></h4>
                        <h4 class="ant-list-item-meta-title"><b>{i18n.t('components.wiki.nolinks')}</b></h4>
                      </div>
                    </div>
                  </li>
                </ul> 
              }
              {hasWikiPage &&               
          <ul class="ant-list-items">
            <li class="ant-list-item" style={{borderBottomRightRadius: 0, borderBottomLeftRadius: 0}}>
              <div class="ant-list-item-meta">
                <div class="ant-list-item-meta-content">
                  <h4 class="ant-list-item-meta-title"><span class="csi_cat_title">{i18n.t('components.wiki.title')}</span></h4>
                </div>
              </div>
            </li>
            {wikies.map((item, i) => 
                <WikiPageListItem key={i} page={item} factory={factory} 
                    onDelete={(e, iri, header) => this.handleDeleteWiki(e, iri, header)}
                    canDeleted={isModified}
                />
            )}
          </ul>
              }
      </span>
    );
  }
}

//Представление информации о Wiki статьях
export default connect(
  (state, props) => {
    const { vset, vasset, lwiki} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      wikies: vasset.wikies,      //Текущие wiki страницы
      asset:  vasset.iri,
      selected: lwiki.page,
      nodes: (lwiki.page) ? lwiki.nodes.filter(item => item.nodeId==lwiki.page.nodeId) : [],
    })
  },
  dispatch => ({
    onAddElement (actions, asset, iri, label, description, url, lang){
      return dispatch(actions.addWiki(asset, iri, label, description, url, lang));
    },
    onDeleteElement (actions, asset, iri){
      return dispatch(actions.deleteWiki(asset, iri));
    },
    onLoadDetailWikies (actions, values){
      return dispatch(actions.LOAD_WIKIES(values));
    },
    onLoadNodes(){
      return dispatch(WikiActions.loadNodes());
    },
  })
)(WikiCard)
